let configurations = {
    env: {
        base_url: window.location.origin,
        company_logo: process.env.APP_COMPANY_LOGO,
    },
};

export default configurations;
